import { render, staticRenderFns } from "./batchUpdateProductState.vue?vue&type=template&id=6cd47c3a&scoped=true"
import script from "./batchUpdateProductState.vue?vue&type=script&lang=js"
export * from "./batchUpdateProductState.vue?vue&type=script&lang=js"
import style0 from "./batchUpdateProductState.vue?vue&type=style&index=0&id=6cd47c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd47c3a",
  null
  
)

export default component.exports